import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const inspiration = ['Saved Instagram posts', 'YouTube videos', 'Old notebooks', 'Pose libraries', 'Random sequences', 'Screenshots', 'Previous class plans'];
const structure = ['Complete class intention', 'Full sequence', 'Warm-up', 'Main practice', 'Cooldown', 'Savasana', 'Teaching cues', 'Modifications', 'Timing guidance'];
export function SolutionSection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-18" aria-labelledby="solution-heading" data-id="element-193" data-mp="3t96ml63qctd4">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-194" data-mp="aunqx68w0bji">
        <div className="mx-auto max-w-2xl text-center" data-id="element-195" data-mp="5vazs9azgib4">
          <div className="flex justify-center" data-id="element-196" data-mp="5vujnvk71grs">
            <SectionLabel data-id="element-197" data-mp="ksbu8kkk6rda">Inspiration vs structure</SectionLabel>
          </div>
          <h2 id="solution-heading" className="mt-3 font-serif text-[1.5rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-198" data-mp="kq7glawuydzt">
            You don’t need more yoga inspiration.
            <span className="block text-forest" data-id="element-199" data-mp="3b971le47x3op">You need classes that are ready to teach.</span>
          </h2>
        </div>

        <div className="mt-6 grid gap-3 sm:grid-cols-2 sm:gap-4" data-id="element-200" data-mp="3fa91zy9vfls9">
          <div className="flex h-full flex-col rounded-2xl border border-sandDark bg-ivory/70 p-4 text-center sm:p-6" data-id="element-201" data-mp="3ka5946dv7tc1">
            <h3 className="text-[0.6rem] font-semibold uppercase tracking-label text-muted" data-id="element-202" data-mp="3pa9otu6y8k17">
              Inspiration is everywhere
            </h3>
            <ul className="mt-3 flex flex-wrap justify-center gap-1.5" data-id="element-203" data-mp="3u6gk8t1pyd4w">
              {inspiration.map(item => <li key={item} className="rounded-full border border-sandDark/80 bg-cream/60 px-2.5 py-1.5 text-[0.7rem] leading-none text-muted" data-id="element-204" data-mp="6vh90ndqsp9t">
                  {item}
                </li>)}
            </ul>
            <p className="mt-4 text-[0.82rem] leading-snug text-muted sm:text-[0.9rem]" data-id="element-205" data-mp="grkbjuciapxa">
              But inspiration still leaves <span className="font-semibold text-ink" data-id="element-206" data-mp="27xqa0urov5ap">you</span>{' '}
              responsible for turning everything into a complete class.
            </p>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-forest/20 bg-ivory p-4 text-center shadow-card sm:p-6" data-id="element-207" data-mp="2mnxiqirw99y7">
            <h3 className="text-[0.6rem] font-semibold uppercase tracking-label text-forest" data-id="element-208" data-mp="2vnaw3mj52io7">
              What Yoga Teacher System™ adds
            </h3>
            <ul className="mt-3 grid grid-cols-2 gap-1.5 text-left" data-id="element-209" data-mp="2rl60ii94rbyx">
              {structure.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-210" data-mp="35kp6p5idsd8l">
                  <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-forest" aria-hidden="true" data-id="element-211" data-mp="30np2z1907mkn" />
                  <span className="text-[0.75rem] leading-snug text-ink sm:text-[0.85rem]" data-id="element-212" data-mp="1b8iohmr2kw6s">
                    {item}
                  </span>
                </li>)}
            </ul>
            <p className="mt-4 text-[0.82rem] leading-snug text-muted sm:text-[0.9rem]" data-id="element-213" data-mp="3hwrc8y8aiby4">
              The structure that comes <span className="italic" data-id="element-214" data-mp="3mu9nwwdoz59t">after</span> the inspiration.
            </p>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center font-serif text-[1.05rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-215" data-mp="385my20qfuv4c">
          The class is already structured.
          <span className="mt-1 block text-forest" data-id="element-216" data-mp="2z3nfv53otkzt">You bring the teaching.</span>
        </p>
      </div>
    </section>;
}